<template>
  <v-dialog
    width="900"
    persistent
    scrollable
    v-model="isOpened"
  >
    <v-form @submit.prevent.native="$canWrite && (save($event))">
      <v-card>
        <v-card-title>
          Assigner l'intervention à un utilisateur
          <v-spacer />
          <v-btn icon @click="isOpened = false" v-if="!isSaving">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />

        <v-card-text class="pa-12" v-if="!hasIntervention">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text class="pa-5" v-else>
          <v-alert
            :value="true"
            type="error"
            class="mb-2"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <v-row>
            <v-col class="pa-3">
              <v-select
                label="Utilisateur*"
                :items="users"
                v-model="assigneeId"
                item-value="id"
                item-text="name"
                hide-details
                outlined
                :loading="isFetchingUsers"
                :disabled="isFetchingUsers"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-row no-gutters justify="center" align="center" class="px-3">
            <v-spacer />
            <v-btn text @click="isOpened = false" class="mr-4" v-if="!isSaving">Annuler</v-btn>
            <v-btn :disabled="!$canWrite" type="submit" :loading="isSaving" color="primary darken-1">Assigner</v-btn>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: `InterventionChangeAssignee`,
  props: [`intervention`],
  data: () => ({
    isOpened: true,
    isSaving: false,
    isFetchingUsers: true,
    errors: [],
    dbUsers: [],
    assigneeId: null,
    comment: ``,
    statusId: null,
  }),
  computed: {
    hasIntervention() {
      return this.intervention && this.intervention !== null;
    },
    users() {
      return _.chain(this.dbUsers)
        .filter(user => !user.isExcludedFromPlanning)
        .map(user => ({
          ...user,
          name: `${user.firstname} ${user.lastname}`,
        }))
        .value();
    },
  },
  methods: {
    async save() {
      this.errors = [];
      if (!this.assigneeId) { this.errors.push(`Veuillez sélectionner un utilisateur`); }
      if (!this.errors.length) {
        this.isSaving = true;
        const intervention = await this.$store.dispatch(`model/intervention/changeAssignee`, {
          interventionId: this.intervention.id,
          assigneeId: this.assigneeId,
        });
        this.$emit(`updated`, intervention);
      }
    },
    async fetchUsers() {
      this.isFetchingUsers = true;
      this.dbUsers = await this.$store.dispatch(`model/user/fetchForClient`, this.intervention.Maker_id);
      this.isFetchingUsers = false;
    },
  },
  beforeMount() {
    if (this.hasIntervention) {
      this.statusId = this.intervention.Status_id;
      this.assigneeId = this.intervention.Assignee_id;
      this.fetchUsers();
    }
  },
  watch: {
    isOpened(isOpened) {
      if (!isOpened) {
        this.$emit(`close`);
      }
    },
    hasIntervention(hasIntervention) {
      if (hasIntervention) {
        this.statusId = this.intervention.Status_id;
        this.assigneeId = this.intervention.Assignee_id;
        this.fetchUsers();
      }
    },
  },
  components: {
  },
};
</script>

<style lang="scss">
</style>
